import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import segmentLabelMap from 'sharedParts/config/segmentLabelMap';

import RatingSegmentItem from '../RatingSegmentItem';
import styles from './RatingNumericItem.scss';

const RatingNumericItem = ({
  full,
  empty,
  handleChange,
  isItemSelected,
  index,
  value,
  segmentType,
  segmentLabelList,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const onMouseEnter = (event) => {
    event.preventDefault();
    setIsHovered(true);
  };

  const onMouseLeave = (event) => {
    event.preventDefault();
    setIsHovered(false);
  };

  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={(event) => {
        handleChange({ event, index, value });
      }}
      className={cx(segmentType !== segmentLabelMap.noSegment && styles['item-container'])}
    >
      {isHovered || isItemSelected ? full : empty}
      {segmentType === segmentLabelMap.itemList && (
        <RatingSegmentItem
          className={styles['mobile-segment-item']}
          text={segmentLabelList && segmentLabelList[index] && segmentLabelList[index].value}
        />
      )}
    </div>
  );
};

RatingNumericItem.propTypes = {
  full: PropTypes.element,
  empty: PropTypes.element,
  handleChange: PropTypes.func,
  isItemSelected: PropTypes.bool,
  value: PropTypes.number,
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  segmentType: PropTypes.string,
  segmentLabelList: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, value: PropTypes.string })),
};

export default RatingNumericItem;
